var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 339.899,
    viewBox: "0 0 1920 339.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M2510.937,696.092s34.028-127.448,159.246-88.891,247.9,112.759,334.851,59.121,155.26-11.791,212.671,29.77,240.321,20.131,284.067-29.77,122.6-11.385,141.557-23.707,25.7-86.5,97.44-50.571,165.114,44.7,168.239,89.869,330.76-23.872,374.417-89.869,147.512,50.571,147.512,50.571V911.708h-1920Z",
    transform: "translate(-2510.937 -571.809)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageLine);
export default __webpack_public_path__ + "static/media/homepage-line.fab40fba100c8b7b8f863c45f7863b19.svg";
export { ForwardRef as ReactComponent };